// extracted by mini-css-extract-plugin
export default {"cell_wrapper":"ProjectProtocolsTableHeaderCell_cell_wrapper__mH6yj"};